import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=0a4b42a1&scoped=true&"
import script from "./ClientSearch.vue?vue&type=script&lang=ts&"
export * from "./ClientSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b42a1",
  null
  
)

export default component.exports